export default "__VITE_ASSET__6b4a3daa__"